import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-130e6118"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lux-composer" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-wrap gap-2 mb-3"
}
const _hoisted_3 = ["disabled", "onClick"]
const _hoisted_4 = { class: "d-flex align-items-end gap-3" }
const _hoisted_5 = ["placeholder", "disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-send fs-4" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_11 = { class: "d-flex justify-content-between mt-2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 fs-8" }, "Enter envia, Shift+Enter quebra linha.", -1))
const _hoisted_13 = {
  key: 0,
  class: "text-gray-500 fs-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.suggestions.length && _ctx.showSuggestions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion) => {
            return (_openBlock(), _createElementBlock("button", {
              key: suggestion,
              type: "button",
              class: "btn btn-sm btn-light-primary text-start",
              disabled: _ctx.disabled,
              onClick: ($event: any) => (_ctx.pick(suggestion))
            }, _toDisplayString(suggestion), 9, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("textarea", {
        ref: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.draft) = $event)),
        class: "form-control form-control-solid",
        rows: "1",
        placeholder: _ctx.placeholder,
        disabled: _ctx.disabled,
        onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["exact","prevent"]), ["enter"])),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.autoGrow && _ctx.autoGrow(...args)))
      }, null, 40, _hoisted_5), [
        [_vModelText, _ctx.draft]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.disabled || !_ctx.draft.trim(),
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, [
        (!_ctx.sending)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
          : (_openBlock(), _createElementBlock("span", _hoisted_10))
      ], 8, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      (_ctx.remaining !== null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.remaining) + " mensagens restantes hoje ", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}